import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import FloatingCTA from "./FloatingCTA";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-sand">
      <Header />
      <main className="flex-1 pb-16 md:pb-0">
        <Outlet />
      </main>
      <Footer />
      <FloatingCTA />
    </div>
  );
}
